import React, { FC } from 'react'
import { ChasingDots } from 'styled-spinkit'
import { useAppTheme } from '../../defaultTheme'

type Props = {
  'data-test'?: string
}

export const ChasingDotsLoader: FC<Props> = props => {
  const theme = useAppTheme()
  return <ChasingDots data-test={props['data-test']} color={theme?.loading} />
}

export type ChasingDotsLoaderProps = Props
